// extracted by mini-css-extract-plugin
export default {"link":"Link_link__FfxQn","disableLink":"Link_disableLink__-poNH"};